function normalizeProperties(properties) {

    if (!properties)
        return [];

    return Array.isArray(properties) ? properties : [properties];

}

function getValue(item, property) {

    if (typeof property === 'function')
        return property(item);

    return item?.[property];

}

function createComparator(properties, options = {}) {

    const normalizedProperties = normalizeProperties(properties);
    const {
        locale = undefined,
        nulls = 'first',
    } = options || {};

    if (normalizedProperties.length === 0)
        return () => 0;

    return (a, b) => {

        for (const property of normalizedProperties) {

            const valueA = getValue(a, property);
            const valueB = getValue(b, property);

            const valueAEmpty = valueA === null || valueA === undefined;
            const valueBEmpty = valueB === null || valueB === undefined;

            if (valueAEmpty && valueBEmpty)
                continue;
            if (valueAEmpty)
                return nulls === 'last' ? 1 : -1;
            if (valueBEmpty)
                return nulls === 'last' ? -1 : 1;

            if (typeof valueA === 'string' && typeof valueB === 'string') {
                const comparison = valueA.localeCompare(valueB, locale, {
                    sensitivity: 'base',
                    numeric: true,
                });
                if (comparison !== 0)
                    return comparison;
                continue;
            }

            if (valueA < valueB)
                return -1;
            if (valueA > valueB)
                return 1;

        }

        return 0;

    };

}

function sortCollectionBy(collection, properties, options = {}) {

    if (!collection)
        return collection;

    return collection.sort(createComparator(properties, options));

}

function sortedCollectionBy(collection, properties, options = {}) {

    if (!collection)
        return collection;

    return [...collection].sort(createComparator(properties, options));

}

export {
    createComparator,
    sortCollectionBy,
    sortedCollectionBy,
};
